var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"color-icon",attrs:{"src":_vm.color.img,"title":_vm.color.name + ' (' + Math.round(_vm.color.percent * 100) + '%)'}})}
var staticRenderFns = []

export { render, staticRenderFns }